"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.like = exports.getViewport = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _input = _interopRequireDefault(require("../input"));

var _useDebounce = _interopRequireDefault(require("../useDebounce"));

var _usePrevious = _interopRequireDefault(require("../usePrevious"));

var _virtualList = require("../virtual-list");

var _autocompleteModule = _interopRequireDefault(require("./autocomplete.module.scss"));

var _excluded = ["className", "inputClassName", "icon", "source", "disabled", "value", "query", "multiple", "label", "hideLabel", "debounceTime", "onChange", "onQueryChange", "onFocus", "onBlur", "filterFunction", "sortFunction", "optionRenderer", "isFetchingMore", "canFetchMore", "fetchMore"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getViewport = function getViewport() {
  return {
    height: window.innerHeight || document.documentElement.offsetHeight,
    width: window.innerWidth || document.documentElement.offsetWidth,
    scrollX: window.scrollX,
    scrollY: window.scrollY
  };
};

exports.getViewport = getViewport;

var like = function like(value, userInput) {
  return String(value).toLowerCase().includes(String(userInput).toLowerCase());
};

exports.like = like;

var Autocomplete = function Autocomplete(_ref) {
  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      icon = _ref.icon,
      source = _ref.source,
      disabled = _ref.disabled,
      value = _ref.value,
      initialQuery = _ref.query,
      multiple = _ref.multiple,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      debounceTime = _ref.debounceTime,
      onChange = _ref.onChange,
      onQueryChange = _ref.onQueryChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      filterFunction = _ref.filterFunction,
      sortFunction = _ref.sortFunction,
      _optionRenderer = _ref.optionRenderer,
      isFetchingMore = _ref.isFetchingMore,
      canFetchMore = _ref.canFetchMore,
      fetchMore = _ref.fetchMore,
      others = _objectWithoutProperties(_ref, _excluded);

  var firstUpdate = (0, _react.useRef)(true);
  /** state for query value */

  var _useState = (0, _react.useState)(initialQuery || source[value] || ''),
      _useState2 = _slicedToArray(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];
  /** state to indicate if suggestion list should be shown */


  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showOptions = _useState4[0],
      setShowOptions = _useState4[1];
  /** handle selection of suggestion */


  var selectSuggestion = (0, _react.useCallback)(function (newValue) {
    setQuery(source[newValue] || '');

    if (!multiple) {
      onChange(newValue);
    }
  }, [multiple, onChange, source]);
  /** select by query when multiple values should be returned */

  var debouncedQuery = (0, _useDebounce["default"])(query, debounceTime);
  var prevDebouncedQuery = (0, _usePrevious["default"])(debouncedQuery);
  (0, _react.useEffect)(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (debouncedQuery !== prevDebouncedQuery) {
      onQueryChange(debouncedQuery);

      if (multiple) {
        if (debouncedQuery === '') {
          onChange(null);
        } else {
          var matchingKeys = Object.entries(source);

          if (filterFunction) {
            matchingKeys = matchingKeys.filter(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  _ref3$ = _ref3[1],
                  sourceLabel = _ref3$ === void 0 ? '' : _ref3$;

              return filterFunction(sourceLabel, debouncedQuery);
            });
          }

          matchingKeys = matchingKeys.map(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 1),
                key = _ref5[0];

            return key;
          });
          onChange(matchingKeys);
        }
      }
    }
  }, [multiple, debouncedQuery, source, prevDebouncedQuery, onQueryChange, onChange, query, filterFunction]);
  /** calculate position for suggestion list  */

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      listStyle = _useState6[0],
      setListStyle = _useState6[1];

  var inputElement = (0, _react.useRef)();
  var handleFocus = (0, _react.useCallback)(function (event) {
    event.stopPropagation();

    if (inputElement.current) {
      var _getViewport = getViewport(),
          scrollY = _getViewport.scrollY,
          scrollX = _getViewport.scrollX;

      var _inputElement$current = inputElement.current.getBoundingClientRect(),
          inputX = _inputElement$current.left,
          inputY = _inputElement$current.top,
          inputHeight = _inputElement$current.height,
          inputWidth = _inputElement$current.width;

      var left = inputX + scrollX;
      var top = inputY + inputHeight + scrollY; // max height of list should either be 45% of the viewport or the space to the window border - 30px for spacing

      var spaceToWindowEnd = window.innerHeight - (inputY + inputHeight);
      var viewportMaxHeight = window.innerHeight * 0.45;
      setListStyle({
        top: top,
        left: left,
        width: inputWidth,
        maxHeight: Math.min(spaceToWindowEnd - 30, viewportMaxHeight)
      });
    }

    setShowOptions(true);
    onFocus();
  }, [onFocus]);
  /** handle blur */

  var handleBlur = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    setShowOptions(false);
    onBlur();
  }, [onBlur]); // hide the options if the input position has changed after scrolling

  var handleScroll = (0, _react.useCallback)(function () {
    if (inputElement.current && showOptions) {
      var _getViewport2 = getViewport(),
          scrollY = _getViewport2.scrollY,
          scrollX = _getViewport2.scrollX;

      var _inputElement$current2 = inputElement.current.getBoundingClientRect(),
          inputX = _inputElement$current2.left,
          inputY = _inputElement$current2.top,
          inputHeight = _inputElement$current2.height,
          inputWidth = _inputElement$current2.width;

      var left = inputX + scrollX;
      var top = inputY + inputHeight + scrollY;

      if (top !== listStyle.top || left !== listStyle.left || inputWidth !== listStyle.width) {
        inputElement.current.blur();
      }
    }
  }, [listStyle.left, listStyle.top, listStyle.width, showOptions]); // add and remove scroll event listener

  (0, _react.useEffect)(function () {
    document.addEventListener('scroll', handleScroll, true);
    return function () {
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, [handleScroll]);
  var suggestions = (0, _react.useMemo)(function () {
    var result = Object.entries(source);

    if (filterFunction) {
      result = result.filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            l = _ref7[1];

        return filterFunction(l, query);
      });
    }

    result = result.map(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          k = _ref9[0],
          l = _ref9[1];

      return {
        value: k,
        label: l
      };
    });

    if (sortFunction) {
      result = result.sort(sortFunction);
    }

    return result;
  }, [filterFunction, query, sortFunction, source]);

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      activeIndex = _useState8[0],
      setActiveIndex = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      selected = _useState10[0],
      setSelected = _useState10[1];
  /** handle clear */


  var handleClear = (0, _react.useCallback)(function () {
    selectSuggestion(null);
    setActiveIndex(null);
  }, [selectSuggestion]);
  /** handle active value */

  var selectOrCreateActiveItem = function selectOrCreateActiveItem() {
    var target = activeIndex;

    if (!target) {
      var _ref10 = _toConsumableArray(suggestions.keys());

      target = _ref10[0];
      setActiveIndex(target);
    }

    if (selected) {
      selectSuggestion(selected);
    }
  };
  /** handle key down */


  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (event.key === 'Enter') selectOrCreateActiveItem(event);
  };
  /** handle key up */


  var handleOnKeyUp = (0, _react.useCallback)(function (event) {
    if (event.key === 'Escape') handleBlur(event);

    if (event.key === 'ArrowDown') {
      var index = (activeIndex + 1) % suggestions.length;
      if (activeIndex === null) index = 0;
      setActiveIndex(index);
      setSelected(suggestions[index].value);
    }

    if (event.key === 'ArrowUp') {
      var _index = (activeIndex + suggestions.length - 1) % suggestions.length;

      if (activeIndex === null) _index = suggestions.length - 1;
      setActiveIndex(_index);
      setSelected(suggestions[_index].value);
    }
  }, [activeIndex, handleBlur, suggestions]); // make a query reset possible with value change

  var _useState11 = (0, _react.useState)(value),
      _useState12 = _slicedToArray(_useState11, 2),
      prevValue = _useState12[0],
      setPrevValue = _useState12[1];

  if (value !== prevValue) {
    setPrevValue(value);

    if (multiple) {
      if (Array.isArray(value) && value.length === 1) {
        setQuery(source[value[0]] || '');
      } else if (value === null) {
        setQuery('');
      }
    } else {
      setQuery(source[value] || '');
    }
  }

  var defaultOptionRenderer = function defaultOptionRenderer(_ref11) {
    var measureRef = _ref11.measureRef,
        key = _ref11.key,
        style = _ref11.style,
        option = _ref11.option,
        optionIndex = _ref11.optionIndex;
    var isSelected = value === option.value;
    var isActive = optionIndex === activeIndex;
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: function ref(element) {
        return measureRef(element);
      },
      key: key,
      tabIndex: 0,
      style: style,
      role: "option",
      "aria-selected": isSelected,
      className: (0, _classnames["default"])('bg-white hover:bg-gray-200 break-all text-base cursor-pointer p-1 text-primary', {
        'font-bold': isSelected,
        'bg-gray-200': isActive
      }),
      onMouseDown: function onMouseDown() {
        selectSuggestion(option.value);
      }
    }, option.label);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_autocompleteModule["default"].autocomplete, className)
  }, icon, /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({}, others, {
    className: (0, _classnames["default"])(_autocompleteModule["default"].autocompleteInput, inputClassName),
    ref: inputElement,
    disabled: disabled,
    label: label,
    hideLabel: hideLabel,
    value: query,
    onChange: function onChange(newQuery) {
      setQuery(newQuery);

      if (newQuery === '') {
        setActiveIndex(null);
      }
    },
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleOnKeyDown,
    onKeyUp: handleOnKeyUp
  })), !disabled && query && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "forms.autocomplete.reset"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      onClick: handleClear,
      title: message,
      className: _autocompleteModule["default"].clearButton
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Clear, {
      role: "button",
      className: "w-full h-full block"
    }));
  }), showOptions && /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('z-50 absolute text-base shadow bg-white', _autocompleteModule["default"].suggestionList),
    style: {
      position: 'absolute',
      width: listStyle.width,
      top: listStyle.top,
      left: listStyle.left
    }
  }, /*#__PURE__*/_react["default"].createElement(_virtualList.VirtualList, {
    width: listStyle.width,
    maxHeight: listStyle.maxHeight,
    options: suggestions,
    optionRenderer: function optionRenderer(params) {
      return _optionRenderer ? _optionRenderer(_objectSpread(_objectSpread({}, params), {}, {
        isSelected: value === params.option.value,
        isActive: params.optionIndex === activeIndex,
        onOptionSelect: function onOptionSelect() {
          return selectSuggestion(params.option.value);
        }
      })) : defaultOptionRenderer(params);
    },
    isFetchingMore: isFetchingMore,
    canFetchMore: canFetchMore,
    fetchMore: fetchMore
  })), document.body));
};

Autocomplete.propTypes = _objectSpread(_objectSpread({}, _input["default"].propTypes), {}, {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
  className: _propTypes["default"].string,
  source: _propTypes["default"].shape({}),
  query: _propTypes["default"].string,
  label: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  debounceTime: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  onQueryChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  filterFunction: _propTypes["default"].func,
  sortFunction: _propTypes["default"].func,
  optionRenderer: _propTypes["default"].func,
  isFetchingMore: _propTypes["default"].bool,
  fetchMore: _propTypes["default"].func,
  canFetchMore: _propTypes["default"].bool
});

var noop = function noop() {};

Autocomplete.defaultProps = _objectSpread(_objectSpread({}, _input["default"].defaultProps), {}, {
  className: '',
  source: {},
  query: '',
  value: '',
  label: '',
  hideLabel: false,
  disabled: false,
  multiple: false,
  icon: null,
  debounceTime: 0,
  onChange: noop,
  onQueryChange: noop,
  onFocus: noop,
  onBlur: noop,
  filterFunction: like,
  sortFunction: function sortFunction(prev, next) {
    var _prev$label$localeCom, _prev$label;

    return (_prev$label$localeCom = (_prev$label = prev.label) === null || _prev$label === void 0 ? void 0 : _prev$label.localeCompare(next.label)) !== null && _prev$label$localeCom !== void 0 ? _prev$label$localeCom : 1;
  },
  optionRenderer: null,
  isFetchingMore: false,
  fetchMore: null,
  canFetchMore: false
});
var _default = Autocomplete;
exports["default"] = _default;